/* eslint max-len: ["error", 300] */
import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';
import DocumentTitle from 'react-document-title';
import {
  getQuestion,
  getQuestionAutoCreate,
  incrementQuestionViewCounter,
  incrementQuestionCounter,
} from '../modules/Question';
import Question from './Question';
import {getContextualLists} from '../modules/Contextual';
import {getUser} from '../modules/Authenticate';
import {emitEvent} from '../lib/mz';
import {showHome, showNewQuestion} from '../modules/Navigation';
import IntroPanel from './components/IntroPanel';
import BackButton from './components/BackButton';

@connect((state) => ({
  question: state.question.currentQuestion,
  user: state.authenticate.user,
  loadingQuestion: state.question.loadingQuestion,
  widget: state.environment.widget,
  widgetType: state.environment.widgetType,
  context: state.environment.widgetConfig.context,
  contextType: state.environment.widgetConfig.contextType,
}), {
  showHome,
  showNewQuestion,
  incrementQuestionCounter,
  incrementQuestionViewCounter,
  getQuestion,
  getQuestionAutoCreate,
  getUser,
  getContextualLists,
})

export default class QuestionContainer extends Component {
  static propTypes = {
    getQuestion: PropTypes.func.isRequired,
    getQuestionAutoCreate: PropTypes.func.isRequired,
    getContextualLists: PropTypes.func.isRequired,
    getUser: PropTypes.func.isRequired,
    loadingQuestion: PropTypes.bool,
    widget: PropTypes.bool,
    widgetType: PropTypes.string,
    context: PropTypes.string,
    contextType: PropTypes.string,
    question: PropTypes.object,
    routeParams: PropTypes.object.isRequired,
    questionPath: PropTypes.string,
    user: PropTypes.object,
    incrementQuestionViewCounter: PropTypes.func.isRequired,
    incrementQuestionCounter: PropTypes.func.isRequired,
    showHome: PropTypes.func.isRequired,
    showNewQuestion: PropTypes.func.isRequired,
  };

  componentWillMount() {
    const currentUrl = this.props.routeParams.splat;
    const questionAlreadyLoaded = this.props.question && this.props.question.url === currentUrl;
    const isCommentType = this.props.widgetType === 'comment';
    if (!questionAlreadyLoaded) {
      if (isCommentType) {
        this.props.getQuestionAutoCreate(this.props.context, this.props.contextType);
      } else {
        this.props.getQuestion(currentUrl, this.props.contextType);
      }
    }
    if (!this.props.widget) {
      this.props.getContextualLists([
        {name: 'most-viewed-unanswered', order: 'viewed', relatedQuestion: currentUrl, showUnanswered: true},
        {name: 'most-popular-tags'},
      ], this.props.context);
    }
    this.props.getUser();
  }

  componentDidMount() {
    if (this.props.question) {
      this.props.incrementQuestionViewCounter({question_id: this.props.question.id, type: 'views'});
    }
  }

  render() {
    const {loadingQuestion, question, user, widget, widgetType} = this.props;

    const questionDLM = question && (question.deleted || question.moderated || question.locked);

    const voteUp = () => {
      if (questionDLM) { return; }
      emitEvent('CLICK', {eventTitle: 'question-vote-up', module: {type: widgetType}});
      this.props.incrementQuestionCounter({question_id: question.id, type: 'votes_up'});
    };

    const voteDown = () => {
      if (questionDLM) { return; }
      emitEvent('CLICK', {eventTitle: 'question-vote-down', module: {type: widgetType}});
      this.props.incrementQuestionCounter({question_id: question.id, type: 'votes_down'});
    };

    const onHomeClick = (e) => {
      e.preventDefault();
      this.props.showHome(widget, this.props.context);
    };

    const onNewQuestionClick = (e) => {
      e.preventDefault();
      this.props.showNewQuestion();
    };

    let content;
    let title;
    if (loadingQuestion || !question) { // eslint-disable-line no-constant-condition
      title = 'Loading question ...';
      content = null;
    } else {
      title = `${question.title} - answers from TES`;
      content = (
        <Question
          question={question}
          voteUp={voteUp}
          voteDown={voteDown}
          user={user}
          widget={widget}
          widgetType={widgetType}
        />);
    }

    return widget ? content : (
      <DocumentTitle title={title}>
        <div>
          <IntroPanel askQuestionClick={onNewQuestionClick}>
            <BackButton onClick={onHomeClick}>All questions</BackButton>
          </IntroPanel>
          <div className="l-app-padding">
            {content}
            <hr className="content-breaker" />
            <div className="margin-bottom-ml">
              <h3 className="heading heading--semi-bold heading--underline">Formatting Answers</h3>
              <div className="text--xs">
                <p>You can make things <i>_italic_</i> or <b>*bold*</b></p>
                <p>For lists, just start each row with a -</p>
              </div>
            </div>
            <div className="margin-bottom-ml">
              <h3 className="heading heading--semi-bold heading--underline">About Teacher Q&A</h3>
              <div className="text--xs">
                <p>This is a Question and Answer site for educators to help each other with any queries - whether about a curriculum, regulations, or the best classroom resource for a particular lesson.</p>
                <p>Questions that are not questions (e.g. discussion on a topical event) will be closed and redirected to our Community forums.</p>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  }
}
